var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { useAsyncEffect } from 'ii-react-sdk/hooks';
import React, { createContext, useContext, useState } from 'react';
import { useParams } from 'react-router-dom';
import FileTransferApi from '~/api/file-transfer';
import GetFileUrlApi from '~/api/get-file-url';
import convertB64StringToByteArray from '~/utils/convertB64StringToByteArray';
import getDocumentData from './actions/fetchDocument';
import fetchFileName from './actions/fetchFileName';
const DocumentViewContext = createContext({});
const DocumentViewProvider = (props) => {
    const { id } = useParams();
    const [document, setDocument] = useState(null);
    const [fileName, setFileName] = useState(null);
    const [pdf, setPdf] = useState(null);
    const [highlights, setHighlights] = useState([]);
    useAsyncEffect(() => __awaiter(void 0, void 0, void 0, function* () {
        const response = yield getDocumentData(id);
        setDocument(response.data[0]);
    }), []);
    useAsyncEffect(() => __awaiter(void 0, void 0, void 0, function* () {
        const fileTransferInfo = yield GetFileUrlApi.getUrlById(id, false, 'UPLOAD_FILES_BUCKET');
        const jsonBlob = yield FileTransferApi.get(fileTransferInfo.fileTransferUrl);
        const text = yield jsonBlob.text();
        const byteCharacters = atob(yield JSON.parse(text).data);
        const byteArray = yield convertB64StringToByteArray(byteCharacters);
        setPdf(new Blob([byteArray], { type: 'application/pdf' }));
    }), []);
    useAsyncEffect(() => __awaiter(void 0, void 0, void 0, function* () {
        setFileName(yield fetchFileName(id));
    }), []);
    const value = {
        document,
        fileName,
        highlights,
        pdf,
        setHighlights,
    };
    return React.createElement(DocumentViewContext.Provider, Object.assign({ value: value }, props));
};
const useDocumentView = () => {
    const context = useContext(DocumentViewContext);
    if (!context) {
        throw new Error('IDocumentViewContext must be used inside of a DocumentViewProvider');
    }
    return context;
};
export { DocumentViewProvider, useDocumentView, };
